import { environment } from '../../../environments/environment';

export const API_CONFIG = {
  microservices: environment.microservices,
  timeoutMs: environment.timeoutMs,
  appName: environment.appName,
  useMockAuth: environment.useMockAuth,
  production: environment.production
} as const;

/** Une la base de un micro con un path: apiUrl(API_CONFIG.microservices.admin, 'motivos-cancelacion') */
export function apiUrl(microserviceBase: string, path = ''): string {
  const base = microserviceBase.replace(/\/$/, '');
  if (!path) {
    return base;
  }
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}
